module.exports = __webpack_public_path__ + "files/bc6f8931aa899f16bf5b536badc24ffb.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-3.png
// module id = 1474
// module chunks = 60